'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@common/components';
import { useInView } from 'react-intersection-observer';
import { useAffiliateMerchantProducts } from '../_hooks/useAffiliateMerchantProducts';
import { MerchantListEmpty } from './MerchantListEmpty';
import { MerchantProductCard, PRODUCT_GRID_CLASS_NAME } from './MerchantProductCard';
interface MerchantProductAllListProps {
  merchantCode: string;
}
export const MerchantProductAllList = t0 => {
  const $ = _c(15);
  const {
    merchantCode
  } = t0;
  const {
    products,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useAffiliateMerchantProducts(merchantCode);
  let t1;
  if ($[0] !== fetchNextPage || $[1] !== hasNextPage || $[2] !== isFetchingNextPage) {
    t1 = {
      rootMargin: "200px 0px",
      onChange: inView => {
        if (inView && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      }
    };
    $[0] = fetchNextPage;
    $[1] = hasNextPage;
    $[2] = isFetchingNextPage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    ref
  } = useInView(t1);
  if (products.length === 0) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <MerchantListEmpty message={"\uC0C1\uD488\uC744 \uC900\uBE44\uD558\uACE0 \uC788\uC5B4\uC694."} />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== products) {
    t2 = products.map(_temp);
    $[5] = products;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <ul className={PRODUCT_GRID_CLASS_NAME}>{t2}</ul>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== hasNextPage || $[10] !== ref) {
    t4 = hasNextPage ? <div ref={ref} className="flex items-center justify-center py-24"><Spinner /></div> : null;
    $[9] = hasNextPage;
    $[10] = ref;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
function _temp(product) {
  return <li key={product.hotDeal?.affiliateHotDealId ?? product.giftProduct?.affiliateGiftProductLinkId} className="flex"><MerchantProductCard {...product} /></li>;
}